import { useCallback } from 'react';

import type { IDownloadImageOptions } from './useImageDownload.types';

export type { IDownloadImageOptions } from './useImageDownload.types';

export function useImageDownload() {
  const downloadImage = useCallback(async (_options: IDownloadImageOptions) => {}, []);

  return { downloadImage, isDownloading: false };
}
